import React from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import Svg from '@styles/icons/svg';

export default ({ backgroundColor, percentage, name, subtitle, timeTop, timeBottom, C }) => {
  return (
    <View
      style={{
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
      }}
    >
      <View
        style={{
          width: scale(60),
          height: scale(60),
          borderRadius: scale(60),
          backgroundColor: C(backgroundColor),
          justifyContent: 'center',
          alignContent: 'center',
          alignItems: 'center',
        }}
      >
        <Text>
          <Text style={[font['Headline'], { color: C('Label/Light/Primary') }]}>{String(percentage || 0)}</Text>
          <Text style={[font['Small'], { color: C('Label/Light/Primary'), paddingLeft: scale(1) }]}>%</Text>
        </Text>
      </View>
      <View style={{ marginTop: scale(6), marginBottom: scale(3) }}>
        <Text numberOfLines={2} style={[font['Button 3'], { color: C('Label/Light/Primary'), textAlign: 'center', height: subtitle ? undefined : scale(30) }]}>
          {i18n.t(name)}
        </Text>
        {subtitle && (
          <Text numberOfLines={1} style={[font['Caption 2'], { color: C('Label/Light/Tertiary'), textAlign: 'center' }]}>
            {i18n.t(subtitle)}
          </Text>
        )}
      </View>
      <View>
        <Svg icon="OEEArrow" color="Label/Light/Quinary" width={scale(9)} height={scale(34)} />
      </View>
      <View style={{ marginTop: scale(6), justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
        <Text style={[font['Caption 1'], { color: C('Label/Light/Tertiary') }]}>
          {timeTop.h}
          {i18n.t('h')} {timeTop.m}
          {i18n.t('m')}
        </Text>
        <View style={{ width: scale(60), height: scale(1), backgroundColor: C('Label/Light/Tertiary') }}></View>
        <Text style={[font['Caption 1'], { color: C('Label/Light/Tertiary') }]}>
          {timeBottom.h}
          {i18n.t('h')} {timeBottom.m}
          {i18n.t('m')}
        </Text>
      </View>
    </View>
  );
};
